// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__Kx5pU","loginBtn":"LoginForm_loginBtn__A5s2r"};